import React, { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { List, Card, Container, Grid } from "semantic-ui-react";
import { ContextProvider } from "../../providers/app.provider";

const ExistingCustomerMainPage = () => {
  const { indicatorDispatch } = useContext(ContextProvider);
  useEffect(() => {
    indicatorDispatch({
      type: "INDICATOR_SUBMIT",
      payload: "Existing Customer",
    });
  }, []);

  return (
    <Container
      style={{ paddingTop: "10px", paddingLeft: "20px", paddingRight: "20px" }}
    >
      <List>
        <Grid columns="equal">
          <Grid.Column>
            <List.Item>
              <Card
                as={Link}
                to="/existing_customer/upgrade"
                header="Upgrade"
                description="Upgrade Order"
                color="blue"
              />
            </List.Item>
          </Grid.Column>
          <Grid.Column>
            <List.Item>
              <Card
                as={Link}
                to="/existing_customer/addon"
                header="Add on"
                description="Addon Order"
                color="purple"
              />
            </List.Item>
          </Grid.Column>
          <Grid.Column>
            <List.Item>
              <Card
                as={Link}
                to="/existing_customer/new_dsm_license"
                header="New DSM License"
                description="Need a new license"
                color="green"
              />
            </List.Item>
          </Grid.Column>
          <Grid.Column>
            <List.Item>
              <Card
                as={Link}
                to="/existing_customer/cckm"
                header="CCKM"
                description="CCKM order"
                color="violet"
              />
            </List.Item>
          </Grid.Column>
          <Grid.Column>
            <List.Item>
              <Card
                as={Link}
                to="/existing_customer/other"
                header="Other"
                description="Notes"
                color="orange"
              />
            </List.Item>
          </Grid.Column>
        </Grid>
      </List>
    </Container>
  );
};

export default ExistingCustomerMainPage;
